import type { SanityPageBuilderPartnerGalleryItem, SanityPageBuilderPartnerGallerySection, SanityPageBuilderSection } from "@ouster/shared";
import { PartnerGalleryBlockView } from "~/features/blocks/inventory/partner-gallery";
import type { PartnerGalleryViewItem } from "~/features/blocks/inventory/partner-gallery/shared";
import { toCraftLinkArray } from "~/features/sanity/link";
import { toCraftAsset, toCraftMedia } from "~/features/sanity/media";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderPartnerGallerySection;
  };
};
type PartnerGalleryViewItemWithKey = PartnerGalleryViewItem & Pick<SanityPageBuilderPartnerGalleryItem, "_key">;
export function SanityPartnerGallerySection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const items = sectionContent.items?.map<PartnerGalleryViewItemWithKey>(item => {
    const logo = toCraftAsset(item.logo);
    return {
      _key: item._key,
      description: item.description?.length ? <SanityRichText value={item.description} /> : undefined,
      link: toCraftLinkArray(item.link),
      logo: logo ? {
        alt: logo.alt,
        url: logo.src
      } : undefined,
      media: toCraftMedia(item.media),
      title: item.title
    };
  }) ?? [];
  return <PartnerGalleryBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} isHighlighted={sectionContent.isHighlighted} items={items} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} showGalleryNavigation={sectionContent.showGalleryNavigation} />;
}